"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMusicContentCenterDispatch = exports.IMusicPlayerDispatch = exports.IMusicContentCenterEventHandler = exports.MusicCollectionDispatch = exports.MusicChartCollectionDispatch = void 0;
const native_rtc_1 = require("@iris/native-rtc");
const AgoraConsole_1 = require("../util/AgoraConsole");
const IAgoraMediaPlayerDispatch_1 = require("./IAgoraMediaPlayerDispatch");
class MusicChartCollectionDispatch {
    constructor(engine) {
        this._engine = engine;
    }
    // @ts-ignore
    getCount() {
        AgoraConsole_1.AgoraConsole.warn('MusicChartCollection_getCount not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    get_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicChartCollection_get_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.MusicChartCollectionDispatch = MusicChartCollectionDispatch;
class MusicCollectionDispatch {
    constructor(engine) {
        this._engine = engine;
    }
    // @ts-ignore
    getCount() {
        AgoraConsole_1.AgoraConsole.warn('MusicCollection_getCount not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getTotal() {
        AgoraConsole_1.AgoraConsole.warn('MusicCollection_getTotal not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getPage() {
        AgoraConsole_1.AgoraConsole.warn('MusicCollection_getPage not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getPageSize() {
        AgoraConsole_1.AgoraConsole.warn('MusicCollection_getPageSize not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getMusic_8fcdcef(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicCollection_getMusic_8fcdcef not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.MusicCollectionDispatch = MusicCollectionDispatch;
class IMusicContentCenterEventHandler {
    constructor(engine) {
        this._engine = engine;
    }
    notifyEvent(param) {
        this._engine.irisEventHandlerManager.notifyEvent('RtcEngine', param);
    }
    onMusicChartsResult_fb18135(requestId, result, reason) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenterEventHandler_onMusicChartsResult_fb18135 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onMusicCollectionResult_c30c2e6(requestId, result, reason) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenterEventHandler_onMusicCollectionResult_c30c2e6 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onLyricResult_9ad9c90(requestId, songCode, lyricUrl, reason) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenterEventHandler_onLyricResult_9ad9c90 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onSongSimpleInfoResult_9ad9c90(requestId, songCode, simpleInfo, reason) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenterEventHandler_onSongSimpleInfoResult_9ad9c90 not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    onPreLoadEvent_20170bc(requestId, songCode, percent, lyricUrl, state, reason) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenterEventHandler_onPreLoadEvent_20170bc not supported in this platform!');
        this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IMusicContentCenterEventHandler = IMusicContentCenterEventHandler;
class IMusicPlayerDispatch extends IAgoraMediaPlayerDispatch_1.IMediaPlayerDispatch {
    constructor(engine) {
        super(engine);
        this._engine = engine;
    }
    // @ts-ignore
    open_303b92e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicPlayer_open_303b92e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setPlayMode_748bee0(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicPlayer_setPlayMode_748bee0 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IMusicPlayerDispatch = IMusicPlayerDispatch;
class IMusicContentCenterDispatch {
    constructor(engine) {
        this._engine = engine;
    }
    // @ts-ignore
    initialize_df70304(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_initialize_df70304 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    renewToken_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_renewToken_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    release() {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_release not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    registerEventHandler_ae49451(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_registerEventHandler_ae49451 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    unregisterEventHandler(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_unregisterEventHandler not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    createMusicPlayer() {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_createMusicPlayer not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    destroyMusicPlayer_876d086(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_destroyMusicPlayer_876d086 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getMusicCharts_66d4ecd(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_getMusicCharts_66d4ecd not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getMusicCollectionByMusicChartId_8cd0b4d(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_getMusicCollectionByMusicChartId_8cd0b4d not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    searchMusic_3f8cf09(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_searchMusic_3f8cf09 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    preload_bd5a5a3(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_preload_bd5a5a3 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    preload_d3baeab(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_preload_d3baeab not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    removeCache_f631116(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_removeCache_f631116 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getCaches_c4f9978(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_getCaches_c4f9978 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    isPreloaded_f631116(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_isPreloaded_f631116 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getLyric_5ab5efd(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_getLyric_5ab5efd not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getSongSimpleInfo_d3baeab(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_getSongSimpleInfo_d3baeab not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getInternalSongCode_3a3d1e7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MusicContentCenter_getInternalSongCode_3a3d1e7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IMusicContentCenterDispatch = IMusicContentCenterDispatch;
